export default __webpack_public_path__ + "static/tecalis-students_03-39c0536be358bdbb6b3da44ac0526420.png";